/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseCustomToolCallInputDeltaEvent = {
  type: "response.custom_tool_call_input.delta";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  delta: string;
};

/** @internal */
export const ResponseCustomToolCallInputDeltaEvent$inboundSchema: z.ZodType<
  ResponseCustomToolCallInputDeltaEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.custom_tool_call_input.delta"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  delta: z.string(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseCustomToolCallInputDeltaEvent$Outbound = {
  type: "response.custom_tool_call_input.delta";
  sequence_number: number;
  item_id: string;
  output_index: number;
  delta: string;
};

/** @internal */
export const ResponseCustomToolCallInputDeltaEvent$outboundSchema: z.ZodType<
  ResponseCustomToolCallInputDeltaEvent$Outbound,
  z.ZodTypeDef,
  ResponseCustomToolCallInputDeltaEvent
> = z.object({
  type: z.literal("response.custom_tool_call_input.delta"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  delta: z.string(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseCustomToolCallInputDeltaEventToJSON(
  responseCustomToolCallInputDeltaEvent: ResponseCustomToolCallInputDeltaEvent,
): string {
  return JSON.stringify(
    ResponseCustomToolCallInputDeltaEvent$outboundSchema.parse(
      responseCustomToolCallInputDeltaEvent,
    ),
  );
}
export function responseCustomToolCallInputDeltaEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseCustomToolCallInputDeltaEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseCustomToolCallInputDeltaEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseCustomToolCallInputDeltaEvent' from JSON`,
  );
}
